import { Button, Group, Stack } from '@mantine/core';

import { TSDBusinessValidationType } from '@e-origin/shared';

import { Select, TextInput } from '@components';
import { SimulateTsdModalProps } from '@features/tsd/TSDList/CustomsSimulator/types';
import { useSimulateTsdAcceptedFormInitializer } from './useSimulateTsdAcceptedFormInitializer';

const TSD_BUSINESS_VALIDATION_TYPE_OPTIONS = [
  { value: TSDBusinessValidationType.PRESENTATION_NOTIFICATION, label: '007 - IETS007 / PN accepted' },
  { value: TSDBusinessValidationType.PRELODGED, label: '015 - IETS015 / Pre-lodged' },
  { value: TSDBusinessValidationType.COMBINED, label: '115 - IETS115 / Combined TSD accepted' },
  { value: TSDBusinessValidationType.TRANSFERRED, label: '207 - IETS207 / Transfer approved' },
  { value: TSDBusinessValidationType.DECONSOLIDATION, label: '215 - IETS215 / Deconsolidation approved' },
  { value: TSDBusinessValidationType.ACCEPTED_AMENDMENT, label: '413 - IETS413 / Amendment accepted' },
  { value: TSDBusinessValidationType.INVALIDATION, label: '414 - IETS414 / Invalidation accepted' },
  { value: TSDBusinessValidationType.REVOCATION, label: '415 - IETS415 / Revocation accepted' },
];
const TSD_ACCEPTED_STATUS_OPTIONS = [
  { value: '01', label: '01 - Pre-lodged' },
  { value: '02', label: '02 - Accepted' },
];
export const SimulateTsdAccepted: React.FC<SimulateTsdModalProps> = ({ tsd, onHide, onSubmit }) => {
  const {
    form,
    onSubmit: onSubmitForm,
    submitting,
  } = useSimulateTsdAcceptedFormInitializer({
    tsd,
    onHide,
    onSubmit,
  });

  return (
    <form onSubmit={form.onSubmit(onSubmitForm)}>
      <Stack gap="sm" mb="xl">
        <TextInput {...form.getInputProps('crn')} label="CRN" />

        <TextInput {...form.getInputProps('mrn')} label="MRN" placeholder="MRN" />

        <TextInput {...form.getInputProps('frn')} label="FRN" placeholder="FRN" />

        <Select
          {...form.getInputProps('businessValidationType')}
          label="Business validation type"
          placeholder="Select business validation type"
          data={TSD_BUSINESS_VALIDATION_TYPE_OPTIONS}
          clearable
        />

        <Select {...form.getInputProps('status')} label="Status" placeholder="Select status" data={TSD_ACCEPTED_STATUS_OPTIONS} clearable />
      </Stack>

      <Group justify="center">
        <Button type="button" onClick={onHide} disabled={submitting} size="lg" variant="transparent">
          Cancel
        </Button>

        <Button type="submit" loading={submitting} disabled={!form.isValid()} variant="filled" size="lg" data-pw="simulate-iets028-btn">
          Trigger
        </Button>
      </Group>
    </form>
  );
};
